import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "articles-grid"
};
const _hoisted_2 = {
  class: "article-card"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("main", null, [_cache[2] || (_cache[2] = _createElementVNode("h1", null, "投资", -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: "/article/7",
    class: "article-title"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("AI 投资策略分析", -1)]))]),
    _: 1
  }), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "article-date"
  }, "2024年3月21日", -1))])])]);
}